"use client";
import type { IconSvgElement } from "@hugeicons/react";
import { HugeiconsIcon } from "@hugeicons/react";
import type { CmsHugeicon_iconStyle } from "@workspace/casino_core/schema";
import type { FC } from "react";
import { useEffect, useState } from "react";

type Props = {
  iconName: string;
  iconStyle?: CmsHugeicon_iconStyle;
  color?: string;
  size?: number;
  className?: string;
};

const DynamicHugeIcon: FC<Props> = ({
  iconName,
  iconStyle = "stroke",
  color,
  size = 20,
  className,
}) => {
  const [icon, setIcon] = useState<IconSvgElement | null>(null);

  useEffect(() => {
    loadIconForStyle(iconName, iconStyle).then((loaded) => {
      if (loaded) setIcon(loaded as IconSvgElement);
    });
  }, [iconName, iconStyle]);

  if (!icon) return null;

  return (
    <HugeiconsIcon
      icon={icon}
      size={size}
      primaryColor={color ?? "currentColor"}
      style={color ? { color } : undefined}
      className={className}
    />
  );
};

async function loadIconForStyle(name: string, style: string) {
  if (style === "solid") {
    const m = await import("@hugeicons-pro/core-solid-rounded/loader");
    return m.loadIcon(name);
  }
  if (style === "duotone") {
    const m = await import("@hugeicons-pro/core-duotone-rounded/loader");
    return m.loadIcon(name);
  }
  const m = await import("@hugeicons-pro/core-stroke-rounded/loader");
  return m.loadIcon(name);
}

export default DynamicHugeIcon;
